import { fmtMoney } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Wallet } from "lucide-react";

export function MoveOutTotals({ totals, deposit, onDeposit, locked }) {
  const refund = totals.owed > 0 ? null : totals.refund;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="moveout-totals">
      <div className="flex items-center gap-2 mb-4"><Wallet className="h-5 w-5 text-primary" /><h2 className="font-display font-bold text-lg text-slate-900">Deposit statement</h2></div>
      <div className="grid sm:grid-cols-3 gap-4">
        <div>
          <Label className="text-xs text-slate-500">Security deposit held</Label>
          {locked ? <div className="text-2xl font-extrabold font-display text-slate-900 mt-1" data-testid="moveout-deposit">{fmtMoney(totals.deposit)}</div>
            : <Input type="number" min={0} value={deposit} onChange={(e) => onDeposit(e.target.value)} className="mt-1 h-10 text-lg font-bold" data-testid="moveout-deposit" />}
        </div>
        <div>
          <div className="text-xs text-slate-500">Total deductions</div>
          <div className="text-2xl font-extrabold font-display text-rose-600 mt-1" data-testid="moveout-deductions">{fmtMoney(totals.deductions)}</div>
        </div>
        <div>
          <div className="text-xs text-slate-500">{refund === null ? "Balance owed by tenant" : "Refund due to tenant"}</div>
          <div className={`text-2xl font-extrabold font-display mt-1 ${refund === null ? "text-rose-700" : "text-emerald-600"}`} data-testid="moveout-refund">{fmtMoney(refund === null ? totals.owed : refund)}</div>
        </div>
      </div>
    </div>
  );
}
